import React, { useState } from 'react';
import { Close } from "@mui/icons-material";
import api from '../../services/api';

interface LocalMesclarModalProps {
  local: any;
  todosOsLocais: any[];
  onClose: () => void;
  onMesclado: () => void;
}

// Mescla `local` (origem) dentro de outro local escolhido (destino): os
// filhos, aliases e registros da origem passam pro destino, e a origem é
// removida (soft delete). O backend também bloqueia mesclar com um dos
// próprios descendentes — aqui só não OFERECEMOS essa opção inválida.
const LocalMesclarModal: React.FC<LocalMesclarModalProps> = ({ local, todosOsLocais, onClose, onMesclado }) => {
  const [busca, setBusca] = useState('');
  const [uidDestino, setUidDestino] = useState('');
  const [mesclando, setMesclando] = useState(false);
  const [erro, setErro] = useState('');

  const prefixoProprio = `${local.path}${local.uid_pesca_local}.`;
  const opcoes = todosOsLocais.filter((l) => {
    if (l.uid_pesca_local === local.uid_pesca_local) return false;
    if (l.path.startsWith(prefixoProprio)) return false;
    if (busca && !l.nome.toLowerCase().includes(busca.toLowerCase())) return false;
    return true;
  });

  const handleMesclar = async () => {
    if (!uidDestino) return;
    const destino = todosOsLocais.find((l) => l.uid_pesca_local === uidDestino);
    if (!window.confirm(`Mesclar "${local.nome}" dentro de "${destino?.nome}"? Essa ação não pode ser desfeita.`)) return;

    setMesclando(true);
    setErro('');
    try {
      await api.post(`/pesca/locais/${local.uid_pesca_local}/mesclar`, { uid_pesca_local_destino: uidDestino });
      onMesclado();
    } catch (err: any) {
      setErro(err?.response?.data?.message || 'Erro ao mesclar.');
    } finally {
      setMesclando(false);
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <h2 style={{ margin: 0, color: 'var(--green-700, #00b37e)', fontSize: '1.15rem' }}>
            Mesclar "{local.nome}"
          </h2>
          <Close style={{ cursor: 'pointer' }} onClick={onClose} />
        </div>

        <p style={{ fontSize: '0.85rem', color: '#666', margin: '0 0 12px' }}>
          Filhos, aliases e registros de "{local.nome}" passam pro local escolhido abaixo, e "{local.nome}" é removido.
        </p>

        <input
          style={inputStyle}
          placeholder="Buscar local de destino..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
        />

        <div style={{ maxHeight: '220px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '4px', margin: '10px 0' }}>
          {opcoes.map((l) => (
            <button
              key={l.uid_pesca_local}
              type="button"
              onClick={() => setUidDestino(l.uid_pesca_local)}
              style={{
                textAlign: 'left', padding: '8px 10px', borderRadius: '8px', cursor: 'pointer',
                border: uidDestino === l.uid_pesca_local ? '2px solid #03c9fe' : '1px solid #ddd',
                background: uidDestino === l.uid_pesca_local ? '#eaf9ff' : '#fafafa',
              }}
            >
              <strong style={{ fontSize: '0.85rem' }}>{l.nome}</strong>
              <span style={{ fontSize: '0.75rem', color: '#888', marginLeft: '6px' }}>({l.tipo})</span>
            </button>
          ))}
          {opcoes.length === 0 && <p style={{ color: '#999', fontSize: '0.82rem' }}>Nenhum local encontrado.</p>}
        </div>

        {erro && <p style={{ color: '#f75a68', fontSize: '0.85rem' }}>{erro}</p>}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px' }}>
          <button type="button" onClick={onClose} style={secondaryBtnStyle}>Cancelar</button>
          <button type="button" onClick={handleMesclar} disabled={!uidDestino || mesclando} style={primaryBtnStyle}>
            {mesclando ? 'Mesclando...' : 'Mesclar'}
          </button>
        </div>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000,
};
const modalStyle: React.CSSProperties = {
  background: '#fff', borderRadius: '12px', padding: '20px',
  width: '90%', maxWidth: '420px', boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
};
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #ddd', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
};
const primaryBtnStyle: React.CSSProperties = {
  padding: '8px 20px', borderRadius: '20px', border: 'none', background: '#03c9fe', color: '#fff', cursor: 'pointer',
};
const secondaryBtnStyle: React.CSSProperties = {
  padding: '8px 20px', borderRadius: '20px', border: '1px solid #ddd', background: '#fff', color: '#666', cursor: 'pointer',
};

export default LocalMesclarModal;
